<template>
  <div>
    <label :for="id">
      {{ label }}
      <div class="dropzone dropzone-previews dz-clickable" style="position: relative;">
        <input
          type="file"
          multiple
          :name="uploadFieldName"
          :id="id"
          @change="filesChange($event.target.name, $event.target.files);"
          accept="image/*"
          class="input-file"
          :disabled="filenames.length >= max"
        />
        <div class="dz-message" v-if="!uploadedFiles.length">
          <i class="material-icons">cloud_upload</i>
          {{ descricao }}
        </div>
        <div class="image-box row" v-else>
          <div class="col sm3 image-column" v-for="item in uploadedFiles" @click.prevent>
            <i class="material-icons top-icon check" v-if="item.completed">check_circle</i>
            <i class="material-icons top-icon error" v-else-if="item.error">error</i>
            <div class="img-wrapper">
              <img
                ref="imageTarget"
                :src="getUrlData(item.content)"
                class="img-responsive img-thumbnail materialboxed"
                width="120"
                v-if="item.content"
              />
              <div style="padding: 10px" v-else>
                <div class="preloader-wrapper small active">
                  <div class="spinner-layer spinner-green-only">
                    <div class="circle-clipper left">
                      <div class="circle"></div>
                    </div>
                    <div class="gap-patch">
                      <div class="circle"></div>
                    </div>
                    <div class="circle-clipper right">
                      <div class="circle"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="progress" v-if="!item.completed && !item.error">
              <div class="determinate" :style="'width: ' + item.progress + '%'"></div>
            </div>
            <a
              @click.prevent="removefile(item)"
              v-bind:style="{cursor: 'pointer', display: flag }"
              v-if="item.completed"
            >
              <i class="material-icons">delete</i> Remover
            </a>
            <a @click.prevent="tryAgain(item)" style="cursor: pointer;" v-if="item.error">
              <i class="material-icons">replay</i> Tentar novamente
            </a>
          </div>
        </div>

        <div class="footer-message error" v-if="uploadedFiles.length > 0 && hasError">
          <span>
            <i class="material-icons">error</i> Tem erro, reenvie
          </span>
        </div>
        <div class="footer-message notice" v-else-if="uploadedFiles.length > 0 && !allCompleted">
          <span>
            <i class="material-icons">file_upload</i> Enviando...
          </span>
        </div>
      </div>
    </label>    
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: []
    },
    label: String,
    descricao: String,
    max: {
      default: 100
    }
  },
  data: function() {
    return {
     flag: true
    };
  },
  watch: {
    value: function(value) {
      let that = this;

      this.filenames = value;
      that.filenames.forEach(function(filename) {
        if (
          that.uploadedFiles.filter(x => x.filename === filename).length === 0
        ) {
          that.uploadedFiles.push({
            content: filename,
            progress: 100,
            completed: true,
            error: false,
            upload: null,
            filename: filename
          });
        }
      });

      this.$nextTick(() => this.updateMaterialBoxed());
    }
  },
  created() {
    let that = this;
    if (this.value) {
      this.filenames = this.value;
    }

    that.filenames.forEach(function(filename) {
      if (
        that.uploadedFiles.filter(x => x.filename === filename).length === 0
      ) {
        that.uploadedFiles.push({
          content: filename,
          progress: 100,
          completed: true,
          error: false,
          upload: null,
          filename: filename
        });
      }
    });
  },
  mounted() {
    this.$nextTick(() => this.updateMaterialBoxed());
  },
  data() {
    return {
      loading: false,
      filenames: [],
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: "photos",
      id: Math.random().toString(36)
    };
  },
  computed: {
    allCompleted() {
      return (
        this.uploadedFiles.filter(x => x.completed === true).length ===
        this.uploadedFiles.length
      );
    },
    hasError() {
      return this.uploadedFiles.filter(x => x.error === true).length > 0;
    }
  },
  methods: {
    getUrlData(file) {
      return this.isBase64(file) ? file : "/storage/anexos/" + file;
    },
    isBase64(file) {
      return file.substr(0, 5) === "data:";
    },
    filesChange(fieldName, fileList) {
      let that = this;

      if (!fileList.length) return;

      let promisses = Array.from(Array(fileList.length).keys()).map(x => {
        let file = fileList[x];

        let fileType = file["type"];
        let ValidImageTypes = ["image/gif", "image/jpeg", "image/png"];

        if (ValidImageTypes.indexOf(fileType) !== -1) {
          // invalid file type code goes here.
          let reader = new FileReader();

          let item = {
            content: null,
            progress: 0,
            completed: false,
            error: false,
            upload: null,
            filename: null
          };

          that.uploadedFiles.push(item);

          reader.addEventListener("load", function(event) {
            let MAX_WIDTH = 800;
            let MAX_HEIGHT = 800;
            let origImg = new Image();
            origImg.onload = function() {
              let to = document.createElement("canvas");

              let width = origImg.width;
              let height = origImg.height;

              item.content = event.target.result;

              // Don't resize if it's small enough

              if (width > MAX_WIDTH || height > MAX_HEIGHT) {
                if (width > height) {
                  if (width > MAX_WIDTH) {
                    height *= MAX_WIDTH / width;
                    width = MAX_WIDTH;
                  }
                } else {
                  if (height > MAX_HEIGHT) {
                    width *= MAX_HEIGHT / height;
                    height = MAX_HEIGHT;
                  }
                }
              }
              to.width = width;
              to.height = height;

              let context = to.getContext("2d");
              context.drawImage(origImg, 0, 0);

              pica
                .resize(origImg, to)
                .then(result => pica.toBlob(result, "image/jpeg", 90))
                .then(blob => {
                  let filename = that.guid() + ".jpg";

                  // Create a new tus upload
                  let upload = new window.tus.Upload(blob, {
                    endpoint: "/files",
                    uploadUrl: "/files",
                    resume: false,
                    retryDelays: [0, 1000, 3000, 5000],
                    metadata: {
                      filename: filename,
                      filetype: file.type
                    },
                    onError: function(error) {
                      Vue.set(item, "error", true);
                    },
                    onProgress: function(bytesUploaded, bytesTotal) {
                      let percentage = (
                        (bytesUploaded / bytesTotal) *
                        100
                      ).toFixed(2);

                      Vue.set(item, "progress", percentage);
                    },
                    onSuccess: function() {
                      Vue.set(item, "filename", filename);

                      setTimeout(function() {
                        Vue.set(item, "completed", true);
                      }, 1000);
                      console.log(that);
                      that.filenames.push(filename);
                      that.$emit("input", that.filenames);

                      bus.$emit("uploadImagemRealizado");
                    }
                  });

                  // Start the upload
                  upload.start();
                  item.upload = upload;
                });
            };

            origImg.src = event.target.result;
          });

          reader.readAsDataURL(file);
        } else {
          Materialize.toast({ html: "Formato de imagem inválido" });
        }
      });
    },
    guid() {
      return (
        this.s4() +
        this.s4() +
        "-" +
        this.s4() +
        "-" +
        this.s4() +
        "-" +
        this.s4() +
        "-" +
        this.s4() +
        this.s4() +
        this.s4()
      );
    },
    s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    },
    tryAgain(item) {
      item.error = false;
      item.upload.start();
    },
    removefile: function(item) {
      if (!confirm("Deseja relamente excluir esta imagem?")) return false;

      this.uploadedFiles = this.uploadedFiles.filter(
        x => x.filename !== item.filename
      );
      this.filenames = this.filenames.filter(x => x !== item.filename);

      this.$emit("input", this.filenames);
      this.$emit("item", item);
    },
    updateMaterialBoxed() {
      let that = this;
      let options = {
        shown: function() {
          that.$emit("modal-upload-open", true);
        },
        hide: function() {
          that.$emit("modal-upload-open", false);
        },
        viewed: function() {
          let context = $(this);
          //fechar ao clicar fora da imagem
          $(".viewer-canvas").click(e => {
            if (e.target.className === "viewer-canvas") {
              context.viewer("hide");
            }
          });
        },
        url: "data-original"
      };

      if (Array.isArray(this.$refs.imageTarget)) {
        this.$refs.imageTarget.forEach(image => {
          $(image).viewer(options);
        });
      }
      // Estava sobrescrevendo os eventos de todos os itens
      //        $('.materialboxed').viewer(options);
    }
  }
};
</script>

<style lang="scss" scoped>
.dropzone {
  cursor: pointer;
}

.dz-file-preview {
  margin-top: 15px;
}

.dz-image {
  min-height: 150px;
}

.img-wrapper {
  height: 100px;
  overflow: hidden;
  margin-bottom: 5px;
  border-radius: 5px;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  text-align: center;
  position: absolute;
  cursor: pointer;
}

.image-box {
  display: table;

  .image-column {
    border: 1px solid #aaa;
    border-radius: 9px;
    margin: 0 7px 10px 0;
    padding: 10px;
    position: relative;

    i.top-icon {
      position: absolute;
      z-index: 9;
      right: 2px;
      background-color: white;
      border-radius: 35px;
      border: 0;
      top: 5px;

      &.check {
        color: #1bb240;
      }

      &.error {
        color: red;
      }
    }
  }
}

.footer-message {
  width: 100%;
  color: white;
  position: absolute;
  bottom: 0;
  left: 0;
  text-align: center;
  font-size: 14px;

  span {
    position: relative;
    top: -2px;

    i {
      position: relative;
      top: 5px;
    }
  }

  &.check {
    background-color: #1bb240;
  }

  &.notice {
    background-color: #bdbdbd;
  }

  &.error {
    background-color: #ef5350;
  }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/utils/DropFileTus.vue